import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCostCenterCosts from './ReportCostCenterCosts'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportCostCenterCosts} />
    </Switch>
)

export default Components
